// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       //this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cartNotification = document.querySelector('cart-notification');
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       this.cartNotification.setActiveElement(document.activeElement);

//       const submitButton = this.querySelector('[type="submit"]');

//       submitButton.setAttribute('disabled', true);
//       submitButton.classList.add('loading');

//       const body = JSON.stringify({
//         ...JSON.parse(serializeForm(this.form)),
//         sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
//         sections_url: window.location.pathname
//       });

//       fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
//         .then((response) => response.json())
//         .then((parsedState) => {
//           this.cartNotification.renderContents(parsedState);
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           submitButton.classList.remove('loading');
//           submitButton.removeAttribute('disabled');
//         });
//     }
//   });
// }

// ✅ NEW: watch real cart add/update calls (made by custom.js) and remove loader once they finish
// patched only once, safe even if this file runs multiple times
if (!window.__cartFetchPatched) {
  window.__cartFetchPatched = true;
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const urlArg = args[0];
    const url = urlArg instanceof Request ? urlArg.url : urlArg;
    const isCartCall = typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/update'));
    const request = originalFetch.apply(this, args);
    if (isCartCall) {
      request.finally(function () {
        document.querySelectorAll('.product-form__submit.loading').forEach(function (btn) {
          btn.classList.remove('loading');
          btn.removeAttribute('disabled');
          const spinner = btn.querySelector('.btn-loader-spinner');
          if (spinner) spinner.remove();
        });
      });
    }
    return request;
  };
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }
    onSubmitHandler(evt) {
      // ✅ NOTE: hum yahan evt.preventDefault() nahi karte
      // kyunki custom.js already apna khud ka add-to-cart fetch chala raha hai.
      // Yahan sirf loader dikhana hai, actual cart-add logic custom.js ke paas hi rehne do.

      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.classList.contains('loading')) return;

      submitButton.classList.add('loading');
      submitButton.setAttribute('disabled', true);

      if (!submitButton.querySelector('.btn-loader-spinner')) {
        const spinner = document.createElement('span');
        spinner.className = 'btn-loader-spinner';
        submitButton.appendChild(spinner);
      }

      // ✅ safety fallback: agar kisi wajah se cart/add call detect na ho paye,
      // to 6 second baad loader apne aap hat jayega (stuck na rahe)
      setTimeout(function () {
        if (submitButton.classList.contains('loading')) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
          const spinner = submitButton.querySelector('.btn-loader-spinner');
          if (spinner) spinner.remove();
        }
      }, 6000);

      // ✅ agar cartNotification maujood hai to hi use karo, warna crash nahi hoga
      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }
    }
  });
}
